// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d9005a3","455":"531e32cd"}[chunkId] + ".chunk.js";
};